import * as React from 'react';
import { View } from '../../_NEXT_components/View';
import { PhoneCallOnboarding } from '../../_NEXT_components/PhoneCallOnboarding';
import { TitleContainer } from '../TitleContainer';
import { trackPhoneAuthCallOnboardingOkClick, trackPhoneAuthCallOnboardingShow } from '../../utils/tracking';
export var PhoneCallOnboardingContainer = function PhoneCallOnboardingContainer(_ref) {
  var onCall = _ref.onCall;
  React.useEffect(function () {
    trackPhoneAuthCallOnboardingShow();
  }, []);
  var handleOnCall = React.useCallback(function () {
    trackPhoneAuthCallOnboardingOkClick();
    onCall();
  }, [onCall]);
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PhoneCallOnboarding, {
    title: /*#__PURE__*/React.createElement(TitleContainer, {
      indent: "S"
    }),
    onCall: handleOnCall
  }));
};